import * as React from 'react';
import { Typography, useMediaQuery, useTheme } from '@mui/material';

import { SubmitButton } from 'components';
import { CompanyForm } from 'forms';
import { useAppDispatch } from 'store/store.hook';
import { updateLayout } from 'store/slices/layout.slice';

interface ProfileCompanySettingsPageProps {}

export const ProfileCompanySettingsPage: React.FC<ProfileCompanySettingsPageProps> = () => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState<boolean>(false);
  const formRef = React.useRef<any>();
  const submitButtonLabel = down_sm ? 'Update' : 'Update Settings';

  React.useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Company Settings' }));
  }, []);

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <div>
      <Typography variant="h5" sx={{ marginBottom: 2 }}>
        Company Settings
      </Typography>

      <CompanyForm ref={formRef} visibleSlug onSubmitting={(loading) => setLoading(loading)} />

      <Typography sx={{ marginTop: 3, fontSize: 14 }}>Not sure you need cleancode anymore?</Typography>

      <Typography>
        <a
          href="mailto:support@mycora.us"
          style={{ color: '#FFA922', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}
        >
          Contact our support team.
        </a>
      </Typography>

      <SubmitButton loading={loading} label={submitButtonLabel} onClick={onSubmit} sx={{ marginTop: 6 }} />
    </div>
  );
};
